import { render, staticRenderFns } from "./PostTableViewForm.vue?vue&type=template&id=7ad1c204&"
import script from "./PostTableViewForm.vue?vue&type=script&lang=js&"
export * from "./PostTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports